<script setup>
import { ref, onMounted } from 'vue';
import EnDialog from 'Components/base/EnDialog/EnDialog.vue';
import EnBaseActionButton from 'Components/base/EnButton/EnButton.vue';
import { useI18n } from 'vue-i18n';
import EnAutocomplete from 'Components/inputs/EnAutocomplete/EnAutocomplete.vue';

const {t} = useI18n();
const email = ref('');
const model = defineModel({type: Boolean, default: false});
const canImitate = ref(false);
const emailSuggestionsUrl = ref('/api/Users/Emails');

function imitate(email) {
  const url = new URL('/Account/Impersonate', window.location.origin);
  url.searchParams.set('impersonateUserEmail', email);

  window.location.href = url.href;
}

function onImitateButtonClick(closeCallback) {
  const e = email.value.trim();

  if (!e) {
    closeCallback();
    email.value = '';
    return;
  }

  closeCallback();
  imitate(e);
}

function onCloseButtonClick(closeCallback) {
  email.value = '';

  closeCallback();
}
</script>

<template>
  <div>
    <en-dialog v-model="model" :max-width="500" :title="t('common.dashboard.imitateUser')">
      <template #activator="{ props }">
        <slot name="activator" :props="props"></slot>
      </template>

      <template #content-prepend>
        <p>{{ t('common.dashboard.imitateUserDialogText') }}</p>
      </template>

      <template #content>
        <en-autocomplete
            v-model="email"
            id="dialog-imitate-user-input"
            display-expression="Email"
            search-expression="Email"
            item-value="Email"
            :api-uri="emailSuggestionsUrl"
            :label="t('common.dashboard.imitateUserEmailInputLabel')"
            placeholder="john@doe.com"
        ></en-autocomplete>
      </template>

      <template #actions="{ close }">
        <en-base-action-button @click="onCloseButtonClick(close)" size="xs">{{ t('common.cancel') }}</en-base-action-button>

        <en-base-action-button variant="default" size="xs" @click="onImitateButtonClick(close)">
          {{ t('common.buttons.imitate') }}
        </en-base-action-button>
      </template>
    </en-dialog>
  </div>
</template>

<style scoped lang="scss">

</style>
